import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import HeroSection from './components/Home/HeroSection';
import WelcomeSection from './components/Home/WelcomeSection';
import DestinationsSection from './components/Home/DestinationsSection';
import TripsSection from './components/Home/TripsSection';
import WhyBookSection from './components/Home/WhyBookSection';
import JoinHandsSection from './components/Home/JoinHandsSection';
import GallerySection from './components/Home/GallerySection';
import TestimonialSection from './components/Home/TestimonialSection';
import DestinationsPage from './pages/DestinationsPage';
import DestinationDetailPage from './pages/DestinationDetailPage';
import TripsPage from './pages/TripsPage';
import TripDetailPage from './pages/TripDetailPage';
import ContactPage from './pages/ContactPage';
import BlogsPage from './pages/BlogsPage';
import BlogDetailPage from './pages/BlogDetailPage';
import AboutPage from './pages/AboutPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import GalleryPage from './pages/GalleryPage';
import Footer from './components/Footer';

import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<>
            <HeroSection />
            <WelcomeSection />
            <DestinationsSection />
            <TripsSection />
            <WhyBookSection />
            <JoinHandsSection />
            <GallerySection />
            <TestimonialSection />
           
            {/* Other home page components can be added here */}
          </>} />
          <Route path="/destinations" element={<DestinationsPage />} />
          <Route path="/destinations/:slug" element={<DestinationDetailPage />} />
          <Route path="/trips" element={<TripsPage />} />
          <Route path="/trips/:id" element={<TripDetailPage />} />
          <Route path="/blogs" element={<BlogsPage />} />
          <Route path="/blogs/:slug" element={<BlogDetailPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
